/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const MyUser = zod.object({
  acceptedThirdPartyConsents: zod.array(
    zod.object({
      acceptedAt: zod.iso
        .datetime({ offset: true })
        .nullable()
        .describe('ISO 8601 date-time string'),
      termsId: zod.string(),
    }),
  ),
  actorType: zod.enum(['USER']),
  address: zod
    .object({
      addressLine1: zod.string().nullable(),
      addressLine2: zod.string().nullable(),
      country: zod.string().nullable(),
      postcode: zod.string().nullable(),
      state: zod.string().nullable(),
      suburb: zod.string().nullable(),
    })
    .nullable(),
  dob: zod.string().nullable(),
  email: zod.string().nullable(),
  firstName: zod.string(),
  lastName: zod.string().nullable(),
  latestTermsAccepted: zod.boolean(),
  name: zod.string(),
  phoneNumber: zod.string().nullable(),
  profileContentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
  profileImage: zod.union([
    zod.object({
      large: zod.union([
        zod.object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        }),
        zod.null(),
        zod.null(),
      ]),
      medium: zod.union([
        zod.object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        }),
        zod.null(),
        zod.null(),
      ]),
      original: zod.union([
        zod.object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        }),
        zod.null(),
        zod.null(),
      ]),
      small: zod.union([
        zod.object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        }),
        zod.null(),
        zod.null(),
      ]),
      xsmall: zod.union([
        zod.object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        }),
        zod.null(),
        zod.null(),
      ]),
    }),
    zod.null(),
    zod.null(),
  ]),
  sexAtBirth: zod.string().nullable(),
  uuid: zod.uuid().describe('UUID v4 identifier'),
});

export type MyUser = zod.input<typeof MyUser>;
export type MyUserOutput = zod.output<typeof MyUser>;
